const map = {
	"./Uptech-equipment-marker-alerts-icon-new.png": 8971,
	"./Uptech-equipment-marker-alerts-icon.png": 4254,
	"./Uptech-equipment-marker-icon.png": 3084,
	"./Uptech-marker-alerts-icon-high-DoB.png": 5878,
	"./Uptech-marker-alerts-icon-high-animal.png": 8529,
	"./Uptech-marker-alerts-icon-high-boat.png": 6059,
	"./Uptech-marker-alerts-icon-high-deformation.png": 927,
	"./Uptech-marker-alerts-icon-high-electric-tower.png": 316,
	"./Uptech-marker-alerts-icon-high-intrusion.png": 5342,
	"./Uptech-marker-alerts-icon-high-landslide.png": 7695,
	"./Uptech-marker-alerts-icon-high-leaks.png": 1381,
	"./Uptech-marker-alerts-icon-high-machinery.png": 6969,
	"./Uptech-marker-alerts-icon-high-manhole.png": 9111,
	"./Uptech-marker-alerts-icon-high-rock-falling.png": 7656,
	"./Uptech-marker-alerts-icon-high-submarine_impact.png": 6776,
	"./Uptech-marker-alerts-icon-high-temperature.png": 8451,
	"./Uptech-marker-alerts-icon-high-vehicle.png": 5145,
	"./Uptech-marker-alerts-icon-high.png": 3098,
	"./Uptech-marker-alerts-icon-intermediate-DoB.png": 2449,
	"./Uptech-marker-alerts-icon-intermediate-animal.png": 5632,
	"./Uptech-marker-alerts-icon-intermediate-boat.png": 854,
	"./Uptech-marker-alerts-icon-intermediate-deformation.png": 6596,
	"./Uptech-marker-alerts-icon-intermediate-electric-tower.png": 525,
	"./Uptech-marker-alerts-icon-intermediate-intrusion.png": 3029,
	"./Uptech-marker-alerts-icon-intermediate-landslide.png": 1028,
	"./Uptech-marker-alerts-icon-intermediate-leaks.png": 3458,
	"./Uptech-marker-alerts-icon-intermediate-machinery.png": 1602,
	"./Uptech-marker-alerts-icon-intermediate-manhole.png": 5564,
	"./Uptech-marker-alerts-icon-intermediate-rock-falling.png": 3949,
	"./Uptech-marker-alerts-icon-intermediate-submarine_impact.png": 9545,
	"./Uptech-marker-alerts-icon-intermediate-temperature.png": 4056,
	"./Uptech-marker-alerts-icon-intermediate-vehicle.png": 8858,
	"./Uptech-marker-alerts-icon-intermediate.png": 3321,
	"./Uptech-marker-alerts-icon-low-DoB.png": 9426,
	"./Uptech-marker-alerts-icon-low-animal.png": 4493,
	"./Uptech-marker-alerts-icon-low-boat.png": 4639,
	"./Uptech-marker-alerts-icon-low-deformation.png": 4939,
	"./Uptech-marker-alerts-icon-low-electric-tower.png": 6056,
	"./Uptech-marker-alerts-icon-low-intrusion.png": 7922,
	"./Uptech-marker-alerts-icon-low-landslide.png": 1835,
	"./Uptech-marker-alerts-icon-low-leaks.png": 3649,
	"./Uptech-marker-alerts-icon-low-machinery.png": 2269,
	"./Uptech-marker-alerts-icon-low-manhole.png": 635,
	"./Uptech-marker-alerts-icon-low-rock-falling.png": 6116,
	"./Uptech-marker-alerts-icon-low-submarine_impact.png": 804,
	"./Uptech-marker-alerts-icon-low-temperature.png": 9287,
	"./Uptech-marker-alerts-icon-low-vehicle.png": 2869,
	"./Uptech-marker-alerts-icon-low.png": 766,
	"./Uptech-marker-alerts-icon-ok.png": 5264,
	"./Uptech-marker-alerts-icon.png": 4019,
	"./Uptech-marker-icon-inclinometer.png": 2321,
	"./Uptech-marker-icon-intermediate.png": 5093,
	"./Uptech-marker-icon-low.png": 2666,
	"./Uptech-marker-icon-ok.png": 1908,
	"./Uptech-marker-icon.png": 2671,
	"./Uptech-only.png": 8217,
	"./Uptech.png": 2792,
	"./avatar.png": 1584,
	"./danger.png": 4258,
	"./fiber-icon-filled-new.png": 467,
	"./fiber-icon-filled.png": 4758,
	"./fiber-icon.png": 6395,
	"./marker-icon-black.png": 7521,
	"./marker-icon-white.png": 4635,
	"./marker-icon.png": 1867,
	"./no-image.png": 7018,
	"./protection.png": 1194,
	"./ship-cargo-critical.png": 3906,
	"./ship-cargo-protection.png": 3324,
	"./ship-cargo.png": 8830,
	"./ship-fishing-critical.png": 4672,
	"./ship-fishing-protection.png": 9986,
	"./ship-fishing.png": 4732,
	"./ship-high-speed-craft-critical.png": 757,
	"./ship-high-speed-craft-protection.png": 3711,
	"./ship-high-speed-craft.png": 2919,
	"./ship-navigation-critical.png": 2966,
	"./ship-navigation-protection.png": 6304,
	"./ship-navigation.png": 9797,
	"./ship-passenger-critical.png": 734,
	"./ship-passenger-protection.png": 1944,
	"./ship-passenger.png": 2490,
	"./ship-pleasure-critical.png": 5131,
	"./ship-pleasure-protection.png": 6213,
	"./ship-pleasure.png": 4389,
	"./ship-tanker-critical.png": 3667,
	"./ship-tanker-protection.png": 8333,
	"./ship-tanker.png": 5213,
	"./ship-tug-special-critical.png": 6200,
	"./ship-tug-special-protection.png": 3978,
	"./ship-tug-special.png": 7108,
	"./ship-unspecified-critical.png": 3389,
	"./ship-unspecified-protection.png": 4167,
	"./ship-unspecified.png": 1455,
	"./workin-on-it.png": 2961,
	"./yellow-shadow.png": 8998
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5336;